__turbopack_context__.v({
  "button": "ajWQ2a_button",
  "focusAreasList": "ajWQ2a_focusAreasList",
  "root": "ajWQ2a_root",
});
